import { render, staticRenderFns } from "./addBusiness.vue?vue&type=template&id=768d1946&"
import script from "./addBusiness.vue?vue&type=script&lang=js&"
export * from "./addBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports